import { Socket } from 'ngx-socket-io';
import { AuthService } from '@core/services/auth/auth.service';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class ChatSocket extends Socket {
  constructor(private authService: AuthService) {
    super({
      url: `${environment.socketUrl}/chat_gateway`,
      options: { path: '/websocket', autoConnect: false },
    });
    // const token = this.authService.getAuthData().access_token;

    // this.ioSocket['auth'] = { token };
  }
}
